import { graphql, useStaticQuery } from 'gatsby'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import Image from 'src/elements/image/image'
import Heading from 'src/elements/typography/heading'
import Paragraph from 'src/elements/typography/paragraph'
import {
  FirstHeading,
  PassionateImageWrapper,
  PassionateWrapper,
  PreludeParagraph,
  PrologueParagraph,
  SecondHeading
} from './passionateAboutIndependence.styles'

const PassionateAboutIndependence = (): JSX.Element => {
  const { desktopImage, mobileImage }: {
    desktopImage: { gatsbyImageData: IGatsbyImageData },
    mobileImage: { gatsbyImageData: IGatsbyImageData }
  } = useStaticQuery(graphql`{
    desktopImage: contentfulAsset(contentful_id: {eq: "6I42QzWsZgiOr8ffYDKOGh"}) {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
    }
    mobileImage: contentfulAsset(contentful_id: {eq: "5UCbpH47yIV8detfJdRpdl"}) {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
    }
  }
  `)

  return (
    <PassionateWrapper>
      <FirstHeading>
        <Heading
          text="Passionate About Independence"
          size="3rem"
          align="center"
          fontFamily="Walsheim"
        />
      </FirstHeading>
      <PreludeParagraph>
        <Paragraph
          text="We’ve built Mighty Networks to be different. Not just in the software and strategy we offer or the fact that we don’t run ads, but in the relationship we have with you, and you have with your members."
          size="2rem"
          align="center"
          weight="light"
        />
      </PreludeParagraph>
      <SecondHeading>
        <Heading
          text="On a Mighty Network, you:"
          size="2rem"
          align="center"
          fontFamily="Walsheim"
        />
      </SecondHeading>
      <PassionateImageWrapper>
        <Image childImageSharp={desktopImage.gatsbyImageData} alt="Group of rectangles" className="desktop-rectangles" />
        <Image childImageSharp={mobileImage.gatsbyImageData} alt="Group of rectangles mobile" className="mobile-rectangles" />
      </PassionateImageWrapper>
      <PrologueParagraph>
        <Paragraph
          text="This approach serves the emerging vanguard of the Creator Economy – independent creators and modern brands – and acts as a bridge to the rapidly approaching world of community ownership, new member and fan models, and so much more."
          size="1.5rem"
          align="left"
          weight="light"
        />
      </PrologueParagraph>
    </PassionateWrapper>
  )
}

export default PassionateAboutIndependence
